export const html = document.documentElement;
export const body = document.body;

export function getStyleProperty(e) {
	return getComputedStyle(html).getPropertyValue(e);
}
